<template>
  <v-col class="pa-0">
    <v-row class="ma-0 pa-0">
      <v-col align="center" cols="8" offset="2">
        <h2>{{ $translate('LOGIN') }}</h2>
      </v-col>
      <v-col class="text-right">
        <v-icon
          size="20"
          @click="$emit('triggerPopup', { toggle: false, component: 'Login' })"
        >
          ti-close
        </v-icon>
      </v-col>
    </v-row>
    <v-col>
      <GoogleLogin
        :params="clientIdGoogle"
        :onFailure="googleLoginFailure"
        :onSuccess="googleLoginSucces"
        style="width: 100% !important"
      >
        <v-btn
          depressed
          class="text-capitalize"
          large
          block
          style="display: flex !important; padding: 8px !important"
        >
          <v-img
            width="24px"
            max-width="24"
            max-height="24"
            :src="require('../../assets/logos/google.png')"
          />
          <p class="ma-0 text-xs-center">{{ $translate('LOGIN_GOOGLE') }}</p>
        </v-btn>
      </GoogleLogin>
      <v-btn
        @click="facebookLogin"
        depressed
        class="text-capitalize my-2"
        large
        block
        style="padding: 8px !important"
      >
        <v-img
          width="24px"
          max-width="24"
          max-height="24"
          :src="require('../../assets/logos/facebook.png')"
        >
        </v-img>
        <p class="ma-0 text-xs-center">{{ $translate('LOGIN_FACEBOOK') }}</p>
      </v-btn>
      <v-btn
        @click="appleLogin"
        depressed
        class="text-capitalize"
        large
        block
        style="padding: 8px !important"
      >
        <v-img
          width="24px"
          max-width="24"
          max-height="24"
          :src="require('../../assets/logos/apple.png')"
        >
        </v-img>
        <p class="ma-0 text-xs-center">{{ $translate('LOGIN_APPLE') }}</p>
      </v-btn>
    </v-col>
    <v-row justify="center" align="center" class="mx-3 py-4 my-0">
      <v-divider class="mr-2" /> {{ $translate('OR') }}
      <v-divider class="ml-2" />
    </v-row>
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-row class="mx-3 my-0">
        <v-col cols="12" class="pt-1">
          <v-text-field
            v-model="email"
            :rules="emailRules"
            :label="$translate('LOGIN_YOUR_EMAIL')"
            outlined
            required
            hide-details="auto"
          />
        </v-col>
        <v-col cols="12" class="pb-1">
          <v-text-field
            v-model="password"
            :rules="passwordRules"
            :label="$translate('LOGIN_YOUR_PASSWORD')"
            @keydown.enter="login"
            :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
            @click:append="() => (hidePassword = !hidePassword)"
            :type="hidePassword ? 'password' : 'text'"
            outlined
            required
            hide-details="auto"
          />
        </v-col>
        <v-col cols="12" class="pt-0 pb-2" align="end">
          <a @click="onResetPassword" class="text-decoration-underline">
            {{ $translate('RESET_PASS_TITLE') }}
          </a>
        </v-col>
        <v-col cols="12">
          <v-alert
            v-if="errorMessage !== ''"
            color="red"
            dense
            text
            type="error"
            >{{ errorMessage }}</v-alert
          >
          <v-btn
            color="primary"
            depressed
            block
            large
            class="pt-1 primary-font-color"
            :loading="loginBusy"
            @click="login"
          >
            {{ $translate('SIGN_IN') }}
          </v-btn>
        </v-col>
        <v-divider />
      </v-row>
    </v-form>
    <v-card flat color="#d9d9d9" class="mt-3">
      <v-col class="pb-0" align="center">
        <h3 class="mb-0">
          {{ $translate('LOGIN_NO_ACCOUNT_YET') }}
        </h3>
      </v-col>
      <v-col align="center" justify="center">
        <v-btn
          color="primary"
          class="primary-font-color"
          depressed
          large
          @click="
            $emit('triggerPopup', { toggle: true, component: 'Register' })
          "
        >
          {{ $translate('LOGIN_ACCOUNT_CREATION') }}
        </v-btn>
      </v-col>
    </v-card>
  </v-col>
</template>

<script>
import UserObject from '@/objects/UserObject';
import doRequest from '@/api/dssRequest';
import GoogleLogin from 'vue-google-login';
import appConfig from '../../../config/app_config';

export default {
  name: 'AccountLogin',
  components: {
    GoogleLogin,
  },
  props: {
    initialEmail: String,
  },
  data() {
    return {
      clientIdGoogle: {
        client_id:
          '819961578899-kgl1peh7ij93tgrat26v8tgou8gtj95h.apps.googleusercontent.com',
      },
      FB: {},
      valid: true,
      email: '',
      emailRules: [
        (v) => !!v || this.$translate('EMAIL_REQUIRED'),
        (v) => /.+@.+\..+/.test(v) || this.$translate('EMAIL_VALID'),
      ],
      password: '',
      passwordRules: [(v) => !!v || this.$translate('PASSWORD_REQUIRED')],
      hidePassword: true,
      errorMessage: '',
      loginBusy: false,
    };
  },
  mounted() {
    if (this.initialEmail != null) {
      this.email = this.initialEmail;
    }
  },
  methods: {
    appleLogin() {
      window.AppleID.auth.signIn().then((response) => {
        if (response.error != null) {
          return;
        }
        const profile = {};
        profile.token = response.authorization.id_token;
        if (response.user != null) {
          if (response.email != null) {
            profile.email = response.user.email;
          }
        } else {
          profile.email = '';
        }
        this.thirdPartySignIn('Apple', profile);
      });
    },
    facebookLogin() {
      window.FB.login(
        (response) => {
          if (response.status === 'connected') {
            this.facebookLoginSucces();
          } else {
            this.facebookLoginUnSuccessfull();
          }
        },
        { scope: 'email' }
      );
    },
    facebookLoginUnSuccessfull() {
      window.EventBus.fire('activateSnackBar', {
        text: this.$translate('NO_SUCCESS_LOGGED_IN'),
        color: 'error',
      });
    },
    facebookLoginSucces() {
      window.FB.api('/me?fields=email', (response) => {
        const profile = {};
        profile.email = response.email;
        profile.token = window.FB.getAccessToken();
        this.thirdPartySignIn('Facebook', profile);
      });
    },
    googleLoginFailure(error) {
      console.log('failed to login', error);
    },
    googleLoginSucces(googleUser) {
      // Useful data for your client-side scripts:
      const profile = googleUser.getBasicProfile();
      const user = {};
      user.email = profile.getEmail();
      user.token = googleUser.getAuthResponse().id_token;
      this.thirdPartySignIn('Google', user);
    },
    thirdPartySignIn(type, profile) {
      const payload = {
        Email: profile.email,
        Token: profile.token,
        Type: type,
        client_id: appConfig.Userlogin.clientSecret,
      };
      doRequest(
        (response) => {
          this.$store.commit('auth/setUserName', response.data.UserId);
          this.$store.commit('auth/setToken', response.data.AccessToken);
          this.$store.commit('auth/setUserLevel', response.data.UserLevel);

          if (response.data.UserLevel === 6 && response.data.PartnerId !== -1) {
            this.$store.commit('auth/setPartnerId', response.data.PartnerId);
          } else {
            this.$store.commit('auth/setPartnerId', -1);
          }

          if (response.data.PartnerId !== -1 && !this.getSavePartnerId) {
            this.$store.commit('setSavePartnerId', response.data.PartnerId);
          }
          window.EventBus.fire('activateSnackBar', {
            text: this.$translate('SUCCESS_LOGGED_IN'),
            color: 'success',
          });
          UserObject.getUserDataStatic(() => {
            this.$emit('triggerPopup', { toggle: false });
          });
        },
        () => {},
        'thirdPartySignIn',
        this.$store.getters['Account/partnerGroupDetails'].AccountId,
        payload
      );
    },
    login() {
      if (this.$refs.form.validate()) {
        this.user = new UserObject(this.email);
        this.loginBusy = true;
        this.user.userlogin(
          this.password,
          (response) => {
            this.loggedSuccess(response);
          },
          (error) => {
            console.log('ERROR on userLogin', error);
            this.loggedUnsuccessfull();
          }
        );
      } else {
        window.EventBus.fire('activateSnackBar', {
          text: this.$translate('LINDA_FILL_REQUIRED'),
          color: 'warning',
        });
      }
    },
    loggedSuccess(response) {
      this.loginBusy = false;
      this.$emit('triggerPopup', { toggle: false });
      window.EventBus.fire('activateSnackBar', {
        text: this.$translate('SUCCESS_LOGGED_IN'),
        color: 'success',
      });
    },
    loggedUnsuccessfull(error) {
      this.loginBusy = false;
      this.errorMessage = this.$translate('LOGIN_ERROR');
    },
    onResetPassword() {
      this.$emit('triggerPopup', {
        toggle: true,
        component: 'ResetPassword',
        props: {
          initialEmail: this.email,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
